// extracted by mini-css-extract-plugin
export var deliveryRow = "_op-a";
export var fixedHeight = "_op-4";
export var freightLogo = "_op-9";
export var fullWidth = "_op-3";
export var priceColumn = "_op-5";
export var radioSelected = "_op-7";
export var radioUnselected = "_op-6";
export var selectedOption = "_op-2";
export var selectedOptionContainer = "_op-1";
export var selection = "_op-0";
export var tallSkeletonText = "_op-8";